// extracted by mini-css-extract-plugin
export default {"heading":"XU","container":"YU","product_section_row":"ZU","carousel":"aV","carouselwide":"bV","carouselwrapper":"cV","blockwrapper":"eV","product_carousel_row":"fV","headingnarrow":"gV","title":"hV"};
    if(module.hot) {
      // 1721922365799
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  